import {Button} from "antd";
import { FolderViewOutlined, ReloadOutlined } from "@ant-design/icons";
import React from "react";

export const youSignColumns = (onRefresh, onView) => {
  return [
  {
    title: "Fichier",
    dataIndex: "filename",
    key: "filename",
    sorter: (a, b) => a.filename.localeCompare(b.filename),
    width: 190,
  },
  {
    title: "Nom",
    dataIndex: "fullname",
    key: "fullname",
    width: 100,
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: 190,
  },
  {
    title: "Statut",
    dataIndex: "statut",
    key: "statut",
    width: 50,
  },
  {
    title: "",
    key: "action",
    width: "50px",
    align: "right",
    render: (_, record) => (
      <div style={{ display: "flex", gap:8, justifyContent: "flex-end" }}>
        <Button
          title={"Actualiser"}
          type="default"
          icon={<ReloadOutlined />}
          onClick={() => onRefresh(record)}
        />
        <Button
          title={"Voir"}
          type="default"
          icon={<FolderViewOutlined />}
          onClick={() => onView(record)}
        />
      </div>
    ),
  },
]
}
